import { render, staticRenderFns } from "./CardActivateModal.vue?vue&type=template&id=31cf0e16"
import script from "./CardActivateModal.vue?vue&type=script&lang=js"
export * from "./CardActivateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports